import type { Router } from 'vue-router';

// Port of the appUrlOpen listener from customer-apps app.component.ts: native universal/app links
// (https://.../app/...) are translated into in-app routes. The path after `/app/` (incl. query/hash)
// is handed to the router as-is; the locale prefix is added by the router catch-all.
export async function initDeepLinks(router: Router): Promise<void> {
    const { App } = await import('@capacitor/app');

    App.addListener('appUrlOpen', (event) => {
        if (!event.url) {
            return;
        }
        const parsedUrl = event.url.replace(/.*\/app\//, '/');
        router.push(parsedUrl);
    });
}
